var $20c975671d6bbc63$exports = {};
$20c975671d6bbc63$exports = {
    "breadcrumbs": `Navigacijski putovi`
};


export {$20c975671d6bbc63$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
